import {FACTIONS} from '../constants/factions';

/**
 * Брызги крови при попадании по отряду: удар оружием в ближнем бою (см.
 * HexGridRenderer.showMeleeImpact) и попадание выстрела — стрел или валуна
 * (см. landShotAnimation). Капли вылетают из точки попадания по ходу удара,
 * летят дугой и падают на землю, где ненадолго остаются пятна. Крови нет,
 * если отряд не потерял численность (урон погасила крепость).
 *
 * Сила брызг (intensity 0..1) — от потери численности (MELEE) или урона
 * выстрела: lossForFullIntensity единиц и больше — брызги в полную силу.
 * Размеры и расстояния — в долях размера ячейки, времена — в миллисекундах.
 * Брызги идут с обычной длительностью и анимацию боя не задерживают: запись
 * матча их не ждет.
 */
export const BLOOD_SPLATTER = {
  lossForFullIntensity: 6,
  // Сила самого слабого попадания: и единица урона должна быть видна
  minIntensity: 0.35,
  droplets: {
    // Сколько капель при силе 0 и при силе 1
    count: {min: 10, max: 22},
    // Разлет по ходу удара: конус в радианах вокруг направления удара. Часть
    // капель летит в стороны и назад — брызги, а не струя
    spreadRad: 1.5,
    backwardShare: 0.18,
    distanceFactor: {min: 0.25, max: 0.8},
    // Подъем дуги над прямой — капля летит вверх и падает
    liftFactor: {min: 0.1, max: 0.35},
    sizeFactor: {min: 0.06, max: 0.15},
    durationMs: {min: 260, max: 460},
    // Капли вылетают не разом
    maxDelayMs: 60,
  },
  stains: {
    // Пятна на земле там, куда упали капли: только у самых крупных капель
    count: {min: 2, max: 5},
    sizeFactor: {min: 0.22, max: 0.42},
    alpha: 0.85,
    holdMs: 900,
    fadeMs: 900,
  },
  // Цвет по фракции отряда-цели: основной (капли) и темный (пятна). У
  // инсектоидов — зеленоватая гемолимфа, у элементалей — искрящаяся сущность
  colors: {
    default: {drop: 0xb3101b, stain: 0x6e0710},
    byFaction: {
      [FACTIONS.INSECTOIDS]: {drop: 0x8fb021, stain: 0x4f6612},
      [FACTIONS.ELEMENTALS]: {drop: 0x8fd8ff, stain: 0x3a7fb0},
    },
  },
};

/** Цвета брызг для фракции отряда-цели */
export const resolveBloodColors = (factionId) => (
  BLOOD_SPLATTER.colors.byFaction[factionId] || BLOOD_SPLATTER.colors.default
);

/** Сила брызг 0..1 по потере численности (или урону) */
export const resolveBloodIntensity = (loss) => {
  if (!(loss > 0)) {
    return 0;
  }
  return Math.min(1, Math.max(BLOOD_SPLATTER.minIntensity, loss / BLOOD_SPLATTER.lossForFullIntensity));
};
